<template>
	<div class="replace-factor-modal" @click.self="closeModal">
		<FactorSearcher
			:activeBatch="false"
			:selectedList="selectedList"
			class="replace-factor-modal__searcher"
			@addFactor="$emit('replaceFactor', $event)"
		/>
	</div>
</template>
<script>
	export default {
		name: 'ReplaceFactorModal',
		components: {
			FactorSearcher: () =>
				import('@/components/product/FactorSearcher.vue'),
		},
		props: {
			selectedList: {
				type: Array,
				default: () => [],
			},
		},
		methods: {
			closeModal() {
				this.$emit('closeModal');
			},
		},
	};
</script>
<style scoped lang="scss">
	.replace-factor-modal {
		z-index: 9999;
		position: fixed;
		display: flex;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.6);
		align-items: center;
		justify-content: center;

		&__searcher {
			width: 440px;
			height: 220px;
			background: white;
		}

		&::v-deep {
			.factor-searcher__input {
				border-radius: 0 !important;
			}

			.factor-searcher__factor-list {
				height: 184px;
			}
		}
	}
</style>
